import { hasEmptyStringProperty } from "@/utils/string";
import { Stack } from "@mui/material";

import { CrossSellSection } from "./CrossSellSection/CrossSellSection";
import { DefaultRedeemPartnerCarousel } from "./DefaultRedeemPartnerCarousel";
import { FearuredRedeemPartnerCarousel } from "./FearuredRedeemPartnerCarousel";
import { KMVAppIncentiveSection } from "./KMVAppIncentiveSection";
import { PartnerDisplay } from "./PartnerDisplay";
import { PartnerDoubt } from "./PartnerDoubt";
import { RedeemPartnerStepsCarousel } from "./RedeemPartnerStepsCarousel";
import { RedeemPartnerProps } from "./types";

export const RedeemPartner: React.FC<RedeemPartnerProps> = ({ redeemPartner, categoryName, partnerName }) => {
  return (
    <Stack bgcolor="#FFD100" mb={6}>
      <PartnerDisplay {...redeemPartner} />

      <Stack gap="30px" mb={{ xs: "48px", md: "60px" }}>
        <FearuredRedeemPartnerCarousel cards={redeemPartner.featuredProducts} />
        <DefaultRedeemPartnerCarousel cards={redeemPartner.defaultProducts} carouselName="defaultProducts" partnerName={partnerName ?? ""} />
      </Stack>

      <RedeemPartnerStepsCarousel cards={redeemPartner.howUseVoucher?.cards ?? []} title={redeemPartner.howUseVoucher?.title} />

      {!hasEmptyStringProperty(redeemPartner?.kmvAppIncentiveSection) && <KMVAppIncentiveSection {...redeemPartner?.kmvAppIncentiveSection} />}

      <CrossSellSection
        cards={redeemPartner?.relatedProducts}
        title={redeemPartner?.relatedProductsTitle}
        categoryName={categoryName}
        partnerName={partnerName ?? ""}
      />

      <PartnerDoubt
        title={redeemPartner.partnerFaq?.title}
        description={redeemPartner.partnerFaq?.description}
        listQuestionsAnswer={redeemPartner.partnerFaq?.questionsAndAnswerList}
      />
    </Stack>
  );
};
